import pino from 'pino'

const baseLogLevel = 'info'
const logger =
    typeof window === 'undefined'
        ? pino({ level: process.env.LOG_LEVEL || baseLogLevel }) // Node.js: default newline-delimited JSON
        : pino({
              level: baseLogLevel,
              browser: { asObject: true },
          }) // Browser: object logs

export default logger
